/**
 * Cover CSS/SVG de la carte « Motus du jour » : mini-grille façon MotusCover où
 * le mot JOUR se révèle, plus un petit soleil « jour » qui scintille doucement.
 * Purement décoratif (le wrapper de GameCard pose aria-hidden) et **inventé** :
 * aucun lien avec le mot du jour réel — rien de secret n'atteint le DOM (ADR 0003).
 */

type TileState = 'correct' | 'present' | 'absent';

interface Tile {
  state: TileState;
  letter?: string;
}

const ROWS: Tile[][] = [
  [
    { state: 'correct', letter: 'J' },
    { state: 'absent' },
    { state: 'present' },
    { state: 'absent' },
  ],
  [
    { state: 'correct', letter: 'J' },
    { state: 'correct', letter: 'O' },
    { state: 'absent' },
    { state: 'present' },
  ],
  [
    { state: 'correct', letter: 'J' },
    { state: 'correct', letter: 'O' },
    { state: 'correct', letter: 'U' },
    { state: 'correct', letter: 'R' },
  ],
];

const TILE_STYLES: Record<TileState, string> = {
  correct: 'bg-motus-correct text-ink-950',
  present: 'bg-motus-present',
  // Bordure : en thème clair, --motus-absent (ink-700) est blanc → la bordure
  // garde la tuile visible sur la carte.
  absent: 'border border-ink-600/50 bg-motus-absent',
};

export function DailyCover() {
  return (
    <div className="relative flex h-28 items-center justify-center overflow-hidden rounded-lg border border-ink-600/40 bg-app/60">
      <div className="grid grid-cols-4 gap-1.5">
        {ROWS.flatMap((row, r) =>
          row.map((tile, c) => (
            <span
              key={`${r}-${c}`}
              className={`flex h-7 w-7 items-center justify-center rounded-sm font-display text-sm font-bold ${TILE_STYLES[tile.state]}`}
            >
              {tile.letter ?? ''}
            </span>
          )),
        )}
      </div>
      {/* Soleil « un mot par jour » — décoratif, pulse coupé si reduced-motion. */}
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className="absolute right-4 top-3 h-9 w-9 text-sun-400/90 motion-safe:animate-pulse-soft"
      >
        <circle cx="12" cy="12" r="4.2" fill="currentColor" fillOpacity="0.35" />
        <path
          d="M12 2.5v2.8M12 18.7v2.8M2.5 12h2.8M18.7 12h2.8M5.2 5.2l2 2M16.8 16.8l2 2M18.8 5.2l-2 2M7.2 16.8l-2 2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
